import React from 'react';

const NoDiviceFound = () => {
    return (
        <div>
            404 nothing found
        </div>
    );
};

export default NoDiviceFound;